import { View } from "react-native";
import { Avatar, useTheme, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  title: string;
  icon: string;
  iconString: string;
};
export default function DisabledView({ title, iconString, icon }: Props) {
  const tailwind = useTailwind();
  const { colors } = useTheme();
  return (
    <View style={tailwind("items-center mt-8")}>
      <Avatar.Icon
        icon={icon}
        color={colors.onSecondaryContainer}
        style={[
          tailwind("my-8"),
          { backgroundColor: colors.secondaryContainer },
        ]}
      />
      <Text
        variant="bodyLarge"
        style={[
          tailwind("text-center mb-2"),
          { color: colors.onSurfaceVariant },
        ]}
      >
        {title}
      </Text>
      <Text variant="displaySmall" style={tailwind("items-center")}>
        {iconString}
      </Text>
    </View>
  );
}
